/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.TimeClock {
    export class TimeClockContext {
        username: string;
        password: string;
        loginStatus = '';
        timeClockUserId: string;
        isFullAccess:boolean;
        enableTimeClockUser: boolean;
        currentLocation: string;
        // TODO: Register as enums into database
        workTimeViewEnum = ['My Timesheet', 'My Schedule'];
        workTimeDateRangeEnum = ['Today', 'This Week', 'Next Week', 'Last 7 Days'];
        selectedWorkActivityDetail: Model.DataDetail;
        timePunchAuditVerbs = [
            [Model.VerbEnum.ClockInButtonClicked, Model.VerbEnum.ClockOutButtonClicked],
            [Model.VerbEnum.BreakInButtonClicked, Model.VerbEnum.BreakOutButtonClicked]
        ];
        public clock = { time: Date.now(), interval: 5000 };
        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $http: angular.IHttpService,
            protected $translate: angular.translate.ITranslateService,
            protected busyService: Components.Busy.IBusyService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService
        ) {
            this.selectedWorkTimeView = 'My Timesheet';
            this.selectedWorkTimeDateRange = 'This Week';
            this.currentLocation = identityService.current().locationName;
        }

        private _workActivityCriteria = { workActivityCategoryEnumOnly: [Model.WorkActivityCategoryEnum.None] };
        get workActivityCriteria(): object {
            return this._workActivityCriteria;
        }

        get isUserAuthenticated(): boolean {
            return Model.Guard.isSomething(this.timeClockUserId) === true;
        }

        authenticateUser(): void {
            this.loginStatus = '';
            if (Model.Guard.isNothing(this.username) || Model.Guard.isNothing(this.password))
                return;
            var request = {
                userName: this.username,
                password: this.password
            }
            this.dataService.customMethodData('/api/TimeClock/AppAuth', 'POST', request)
                .then(response => {
                    if (response.data.isSessionElevated && Model.Guard.isSomething(response.data.userId)) {
                        // Process valid employee
                        this.timeClockUserId = response.data.userId;
                        this.loginStatus = '';
                        this.initializeTimeClock(true);
                        this.isFullAccess = response.data.isFullAccess;
                    }
                    else if (response.data.isLocalEmployee === false) {
                        // Process non-employee
                        this.timeClockUserId = null;
                        this.loginStatus = `${this.$translate.instant('MESSAGE_TIMECLOCK_EMPLOYEE')} ${this.$translate.instant('MESSAGE_PLEASE_TRY_AGAIN')}`;
                        this.initializeTimeClock(false);
                    }
                    else {
                        // Process invalid employee
                        this.timeClockUserId = null;
                        this.loginStatus = `${this.$translate.instant('LABEL_INVALID_AUTHENTICATION')} ${this.$translate.instant('MESSAGE_PLEASE_TRY_AGAIN')}`;
                        this.initializeTimeClock(false);
                    }
                })
                .catch(reasons => {
                    this.resetClock(reasons);
                })
                .finally(() => {
                    // Clear inputs
                    this.username = '';
                    this.password = '';
                });
        }

        private initializeTimeClock(allow: boolean): void {
            if (allow) {
                this.enableTimeClockUser = true;
                this.loadTimeClockData();
            }
            else {
                this.enableTimeClockUser = false;
                this.timeClockData = null;
            }
        }

        // See TimeClock model on the server
        private _timeClockData: any;
        get timeClockData(): any {
            return this._timeClockData;
        }
        set timeClockData(value: any) {
            this._timeClockData = value;
        }

        get currentEntry(): any {

            this.timeClockData.timeEntries =
                _.sortBy(this.timeClockData.timeEntries, function(o:any) { return o.actionTime; });
            if (Model.Guard.isNothing(this.timeClockData)
                || Model.Guard.isNothing(this.timeClockData.timeEntries)
                || this.timeClockData.timeEntries.length < 1) {
                return null;
            } else {
                // Update current entry and assign indicator
                let currentTimeEntry: any = _.last(this.timeClockData.timeEntries);
                currentTimeEntry.isLastEntry = true;
                return currentTimeEntry;
            }
        }

        updateState(): void {
            this.state = Model.Guard.isSomething(this.currentEntry) ? this.currentEntry.state : Meevo.Model.TimeClockStateEnum.ClockedOut;
        }

        updateDefaultWorkTime(): void {
            let currentTime = moment();
            var currentWorkType = _.find(this.timeClockData.workTypes, (wt: any) => {
                let startTime = moment(wt.startDateTime);
                let endTime = moment(wt.endDateTime);
                return startTime <= currentTime && endTime >= currentTime;
            });
            if (Model.Guard.isSomething(currentWorkType))
                this.selectedWorkActivityDetail = { id: currentWorkType.id, displayName: currentWorkType.displayName };
        }

        loadTimeClockData(): void {
            let uri = `/api/TimeClock/${this.timeClockUserId}`;
            this.dataService.customMethodData(uri, "GET", null)
                .then(response => {
                    this.timeClockData = response.data;
                    this.updateState();
                    this.updateDefaultWorkTime();
                    if (this.timeClockData.isTimeClockLocked) {
                        this.modalService.alert('MESSAGE_TIMECLOCK_EMPLOYEE_HAVE_FUTURE_SCHEDULE', Components.Modal.ModalTranslationModes.Translate);
                    }
                }).catch(reasons => {
                    this.resetClock(reasons);
                });

        }

        private _state: Meevo.Model.TimeClockStateEnum;
        get state(): Meevo.Model.TimeClockStateEnum {
            return this._state;
        }
        set state(value: Meevo.Model.TimeClockStateEnum) {
            this._state = value;
        }

        timePunch(clockTimeType: number, clockTimeDirection: number, trackInfo = true): void {
            if (clockTimeType === 0 && clockTimeDirection === 0 && Model.Guard.isNothing(this.selectedWorkActivityDetail)) {
                this.modalService.alert('MESSAGE_CLOCKIN_REQUIRED_WORK_ACTIVITY', Components.Modal.ModalTranslationModes.Translate);
                return;
            }

            if (trackInfo)
                this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.TimeClockPage, this.timePunchAuditVerbs[clockTimeType][clockTimeDirection], null, this.timeClockUserId));

            let uri = `/api/TimeClock/Action`;
            let timeClockAction = {
                employeeId: this.timeClockUserId,
                workTypeId: Model.Guard.isSomething(this.selectedWorkActivityDetail) ? this.selectedWorkActivityDetail.id : null,
                clockTimeType: clockTimeType,
                clockTimeDirection: clockTimeDirection,
                isFullAccess: this.isFullAccess
            }
            this.dataService.customMethodData(uri, "POST", timeClockAction)
                .then(response => {
                    this.timeClockData = response.data;
                    this.updateState();
                    if (this.enableTimeClockUser)
                        this.loadTimeClockActivityView();
                }).catch(reasons => {
                    this.resetClock(reasons);
                });
        }

        removeTimeEntry(): void {
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.TimeClockPage, Model.VerbEnum.DeleteButtonClicked, null, this.timeClockUserId));
            let uri = `/api/TimeClock/Delete`;
            // Build delete payload
            let timeClockDelete = {
                itemId: this.currentEntry.itemId,
                employeeId: this.timeClockUserId,
                clockTimeType: null,
                clockTimeDirection: null
            }
            // Apply payload type and direction
            switch (this.currentEntry.state) {
                case Meevo.Model.TimeClockStateEnum.ClockedIn:
                    timeClockDelete.clockTimeType = 0;
                    timeClockDelete.clockTimeDirection = 0;
                    break;
                case Meevo.Model.TimeClockStateEnum.BreakOut:
                    timeClockDelete.clockTimeType = 1;
                    timeClockDelete.clockTimeDirection = 1;
                    break;
                case Meevo.Model.TimeClockStateEnum.BreakIn:
                    timeClockDelete.clockTimeType = 1;
                    timeClockDelete.clockTimeDirection = 0;
                    break;
                case Meevo.Model.TimeClockStateEnum.ClockedOut:
                    timeClockDelete.clockTimeType = 0;
                    timeClockDelete.clockTimeDirection = 1;
                    break;
            }
            this.dataService.customMethodData(uri, "DELETE", timeClockDelete)
                .then(response => {
                    this.timeClockData = response.data;
                    this.updateState();
                    if (this.enableTimeClockUser)
                        this.loadTimeClockActivityView();
                }).catch(reasons => {
                    this.resetClock(reasons);
                });

        }

        myTimesheetClockOut() {
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.TimeClockMyTimesheet, Model.VerbEnum.ClockOutButtonClicked, null, this.timeClockUserId));
            this.timePunch(0, 1, false);
        }

        resetClock(reasons: any) {
            // Process login errors
            let error: string = reasons.data.responseStatus.message || reasons.data.responseStatus.errorCode;
            const clockErrors = ['CANNOT_CLOCKOUT_SAME_MINUTE','CANNOT_BREAKIN_SAME_MINUTE'];
            
            if (error.indexOf('CANNOTCLOCKINEARLY') !== 0 && clockErrors.indexOf(error) === -1) {
                this.timeClockUserId = null;
                this.loginStatus = `${this.$translate.instant('LABEL_INVALID_AUTHENTICATION')}. ${this.$translate.instant('MESSAGE_PLEASE_TRY_AGAIN')}`;
                this.initializeTimeClock(false);
            }

        }

        getDisplayName(stateDisplayName: any): string {
            let displayName = stateDisplayName.replace(/([A-Z])/g, ' $1');
            return displayName;
        }

        get showClockIn(): boolean {
            if (Model.Guard.isNothing(this.timeClockUserId) || Model.Guard.isNothing(this.timeClockData)) {
                return false;
            }
            if (Model.Guard.isNothing(this.timeClockData.timeEntries) || this.timeClockData.timeEntries.length < 1) {
                return true;
            } else {
                if (this.timeClockData.isTimeClockLocked) {
                    return false;
                }
                for (var i: number = this.timeClockData.timeEntries.length - 1; i >= 0; i--) {
                    if (this.timeClockData.timeEntries[i].state === Meevo.Model.TimeClockStateEnum.ClockedIn || this.timeClockData.timeEntries[i].state === Meevo.Model.TimeClockStateEnum.BreakOut || this.timeClockData.timeEntries[i].state === Meevo.Model.TimeClockStateEnum.BreakIn ) {
                        return false;
                    }

                    if (this.timeClockData.timeEntries[i].state === Meevo.Model.TimeClockStateEnum.ClockedOut && this.timeClockData.timeEntries[i].actionTime > this.clock.time ) {
                        return false;
                    }

                    if (this.timeClockData.timeEntries[i].state === Meevo.Model.TimeClockStateEnum.ClockedOut) {
                        return true;
                    }
                }
                return true;
            }            
        }

        get showClockOut(): boolean {
            if (Model.Guard.isNothing(this.timeClockData) || this.timeClockData.isTimeClockLocked) {
                return false;
            }
            for (var i: number = this.timeClockData.timeEntries.length - 1; i >= 0; i--) {
                if (this.timeClockData.timeEntries[i].state === Meevo.Model.TimeClockStateEnum.ClockedIn && this.timeClockData.timeEntries[i].actionTime > this.clock.time) {
                    return false;
                }
            }
            return true;
        }
        get showBreakIn(): boolean {
            if (Model.Guard.isNothing(this.timeClockData) || this.timeClockData.isTimeClockLocked) {
                return false;
            }
            for (var i: number = this.timeClockData.timeEntries.length - 1; i >= 0; i--) {
                if (this.timeClockData.timeEntries[i].state === Meevo.Model.TimeClockStateEnum.ClockedIn && this.timeClockData.timeEntries[i].actionTime > this.clock.time) {
                    return false;
                }
            }
            return true;
        }

        get showBreakOut(): boolean {
            if (Model.Guard.isNothing(this.timeClockData) || this.timeClockData.isTimeClockLocked) {
                return false;
            }
            if (Model.Guard.isSomething(this.timeClockData.timeEntries)) {
                for (var i: number = this.timeClockData.timeEntries.length - 1; i >= 0; i--) {
                    if (this.timeClockData.timeEntries[i].state === Meevo.Model.TimeClockStateEnum.ClockedIn && this.timeClockData.timeEntries[i].actionTime > this.clock.time) {
                        return false;
                    }
                }
            }
           return this.state !== Meevo.Model.TimeClockStateEnum.BreakOut;
        }
        get showDelete(): boolean {
            if ((Model.Guard.isSomething(this.timeClockData) && this.timeClockData.isTimeClockLocked))
                return false;
            return true;
        }

        // See WorkTimeView model on the server
        private _timeClockActivityView: any[];
        get timeClockActivityView(): any[] {
            return this._timeClockActivityView;
        }
        set timeClockActivityView(value: any[]) {
            this._timeClockActivityView = value;
        }

        private _selectedWorkTimeView: any;
        get selectedWorkTimeView(): any {
            return this._selectedWorkTimeView;
        }
        set selectedWorkTimeView(value: any) {
            this._selectedWorkTimeView = value;
            if (this.enableTimeClockUser)
                this.loadTimeClockActivityView();
        }

        private _selectedWorkTimeDateRange: any;

        get selectedWorkTimeDateRange(): any {
            return this._selectedWorkTimeDateRange;
        }
        set selectedWorkTimeDateRange(value: any) {

            /*  TODO: Get Calendar Week StartDay/EndDay from business settings  */
            let weekStartDay = moment().startOf('isoWeek').subtract(1, 'days')      /*  Sunday  as is in Schedules  */
            let weekEndDay = moment().endOf('isoWeek').subtract(1, 'days')          /*  Saturday as is in Schedules */

            switch (value) {
                case 'This Week':
                    this.viewDateRange = {
                        startDateTime: weekStartDay.toDate(),
                        endDateTime: weekEndDay.toDate()
                    }
                    break;
                case 'Next Week':
                    this.viewDateRange = {
                        startDateTime: weekStartDay.add(1, 'weeks').toDate(),
                        endDateTime: weekEndDay.add(1, 'weeks').toDate()
                    }
                    break;
                case 'Yesterday':
                    this.viewDateRange = {
                        startDateTime: moment().subtract(1, 'days').startOf('day').toDate(),
                        endDateTime: moment().subtract(1, 'days').endOf('day').toDate()
                    }
                    break;
                case 'Last Week':
                    this.viewDateRange = {
                        startDateTime: weekStartDay.subtract(1, 'weeks').toDate(),
                        endDateTime: weekEndDay.subtract(1, 'weeks').toDate()
                    }
                    break;
                case 'Last 7 Days':
                    this.viewDateRange = {
                        startDateTime: moment().subtract(7, 'days').toDate(),
                        endDateTime: moment().startOf('day').toDate()
                    }
                    break;
                default: // 'Today':
                    this.viewDateRange = {
                        startDateTime: moment().startOf('day').toDate(),
                        endDateTime: moment().endOf('day').toDate()
                    }
                    break;
            }
            this._selectedWorkTimeDateRange = value;
            if (this.enableTimeClockUser)
                this.loadTimeClockActivityView();
        }

        viewDateRange: { startDateTime: any, endDateTime: any };

        loadTimeClockActivityView(): void {
            let uri = `/api/EmployeeTimeClock/View/${this.timeClockUserId}`;
            let timeClockActivity = {
                criteria: {
                    timeClockView: this.selectedWorkTimeView === 'My Timesheet' ? 0 : 1,
                    dateRange: this.viewDateRange
                }
            }
            this.busyService.start();
            this.dataService.customMethodData(uri, "POST", timeClockActivity)
                .then(response => {
                    this.timeClockActivityView = response.data;
                }).catch(reasons => {
                    this.resetClock(reasons);
                }).finally(() => {
                    this.busyService.stop();
                });
        }

        openMySchedule(): void {
            this.selectedWorkTimeView = 'My Schedule';
            let context = this;
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.TimeClockPage, Model.VerbEnum.MyScheduleButtonClicked, null, this.timeClockUserId));
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/timeClock/myScheduleModal.template.html",
                clickOutsideToClose: false,
                locals: {
                    context: context
                },
                controller: "meevo.components.controls.ModalContextController",
                controllerAs: "timeClock"
            };
            this.modalService.showCustom(options);

        }

        openMyTimesheet(): void {
            this.selectedWorkTimeView = 'My Timesheet';
            let context = this;
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.TimeClockPage, Model.VerbEnum.MyTimesheetButtonClicked, null, this.timeClockUserId));
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/timeClock/myTimesheetModal.template.html",
                clickOutsideToClose: false,
                locals: {
                    context: context
                },
                controller: "meevo.components.controls.ModalContextController",
                controllerAs: "timeClock"
            };
            this.modalService.showCustom(options);
        }

    }
}